"use strict";

/**
 * @function
 * @description Fnction to get the content asset body and append it into a modal
 * @param {string} element - the element that contains the data-modal-content attribute
 */
const getAssetContent = (element) => {
    const contentAssetUrl = element.data("modal-content");
    const contentAssetGroup = element.data("modal-group");

    if (contentAssetUrl) {
        $.ajax({
            type: "GET",
            url: contentAssetUrl,
            dataType: "json",
            success: function (data) {
                if (data.modalTemplate) {
                    let $modal = $(".modal");

                    if ($modal.length) {
                        $modal.modal("hide");
                    }

                    $("body").append(data.modalTemplate);

                    const $assetPopup = $("#assetBodyPopup");

                    $assetPopup.modal("show");

                    $(document).on("hide.bs.modal", $assetPopup, () => {
                        $assetPopup.remove();

                        if (element.hasClass("js-goodbye-message")) {
                            sessionStorage.setItem(contentAssetGroup + "PopupShown", true);
                        }
                    });
                }
            }
        });
    }
};

module.exports = getAssetContent;
